module.exports = __webpack_public_path__ + "img/miniapp-qrcode.jpg";